import { render, staticRenderFns } from "./complaintHandDetails.vue?vue&type=template&id=3d960e70&scoped=true&"
import script from "./complaintHandDetails.vue?vue&type=script&lang=js&"
export * from "./complaintHandDetails.vue?vue&type=script&lang=js&"
import style0 from "./complaintHandDetails.vue?vue&type=style&index=0&id=3d960e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d960e70",
  null
  
)

export default component.exports